// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import React, { useState } from "react";

const TEAM_MEMBERS = [
  { name: "Jordan Lutz", initials: "JL", role: "Forge Master" },
  { name: "Ryan Miskulin", initials: "RM", role: "CEO" },
  { name: "Taylor Schenher", initials: "TS", role: "CFO" },
  { name: "Des Bachynski", initials: "DB", role: "Health Ambassador" },
  { name: "Lucas Mason", initials: "LM", role: "VP Sales" },
  { name: "Lee Mehling", initials: "LMe", role: "Mining Ambassador" },
  { name: "Clorice Robertson", initials: "CR", role: "CAO" },
  { name: "Tyson Becker", initials: "TB", role: "Commodities Ambassador" },
  { name: "Tyler Hodgson", initials: "TH", role: "Overwatch" },
];

const MOCK_TASKS_DUE = [
  { id: 1, title: "Finalize Q1 revenue projections", assignee: "Taylor Schenher", priority: "P0", due: "Today" },
  { id: 2, title: "Deploy mining dashboard v2.3", assignee: "Jordan Lutz", priority: "P1", due: "Today" },
  { id: 3, title: "Client demo prep - Canstorr meeting", assignee: "Lucas Mason", priority: "P0", due: "Today" },
  { id: 4, title: "Review health compliance audit", assignee: "Des Bachynski", priority: "P1", due: "Today" },
  { id: 5, title: "Update accounting reconciliation", assignee: "Clorice Robertson", priority: "P2", due: "Today" },
];

const MOCK_OVERDUE = [
  { id: 6, title: "Partnership agreement review - Western Mining", assignee: "Lee Mehling", priority: "P0", daysOverdue: 3 },
  { id: 7, title: "Sales funnel optimization report", assignee: "Lucas Mason", priority: "P1", daysOverdue: 2 },
  { id: 8, title: "Infrastructure scaling proposal", assignee: "Jordan Lutz", priority: "P2", daysOverdue: 1 },
];

const MOCK_MEETINGS = [
  { id: 1, title: "Board Strategy Session", time: "10:00 AM", attendees: ["RM", "TS", "LM"], type: "Internal" },
  { id: 2, title: "Canstorr Commodities Review", time: "1:00 PM", attendees: ["TB", "RM", "LM"], type: "Client" },
  { id: 3, title: "Engineering Sprint Review", time: "3:00 PM", attendees: ["JL", "TH"], type: "Internal" },
  { id: 4, title: "Mining Sector Partnership", time: "4:30 PM", attendees: ["LMe", "RM"], type: "External" },
];

const MOCK_DEALS = [
  { id: 1, name: "Canstorr Expansion", value: "50,000", stage: "Negotiation", rep: "Tyson Becker", probability: 85 },
  { id: 2, name: "Western Mining Integration", value: "80,000", stage: "Proposal", rep: "Lee Mehling", probability: 60 },
  { id: 3, name: "Provincial Health Contract", value: "20,000", stage: "Qualified", rep: "Des Bachynski", probability: 40 },
  { id: 4, name: "Fleet Management Onboarding", value: "75,000", stage: "Proposal", rep: "Lucas Mason", probability: 70 },
  { id: 5, name: "Insurance Broker Platform", value: "10,000", stage: "Negotiation", rep: "Lucas Mason", probability: 80 },
];

const MOCK_ACTIVITY = [
  { id: 1, user: "Jordan Lutz", action: "deployed v2.3 to production", time: "12 min ago", type: "deploy" },
  { id: 2, user: "Lucas Mason", action: "closed deal: Fleet Management Phase 1", time: "45 min ago", type: "deal" },
  { id: 3, user: "Clorice Robertson", action: "completed Q1 financial reconciliation", time: "1 hr ago", type: "task" },
  { id: 4, user: "Tyson Becker", action: "updated Canstorr proposal terms", time: "2 hrs ago", type: "deal" },
  { id: 5, user: "Des Bachynski", action: "submitted health compliance report", time: "2 hrs ago", type: "task" },
  { id: 6, user: "Lee Mehling", action: "logged site visit: Western Mining HQ", time: "3 hrs ago", type: "visit" },
  { id: 7, user: "Taylor Schenher", action: "approved Q1 budget allocation", time: "4 hrs ago", type: "finance" },
  { id: 8, user: "Tyler Hodgson", action: "generated weekly performance report", time: "5 hrs ago", type: "report" },
];
export default function OverwatchPage() {
  const [activeTab, setActiveTab] = useState("overview");
  const totalPipeline = MOCK_DEALS.reduce((s,d)=>s+parseInt(d.value.replace(/[^0-9]/g,"")),0);
  return (<div>
    <div className="page-header"><div><h1>Overwatch Command Center</h1><p>Real-time company overview</p></div></div>
    <div className="stats-grid">
      <div className="stat-card"><div className="stat-label">Tasks Due</div><div className="stat-value">{MOCK_TASKS_DUE.length}</div></div>
      <div className="stat-card"><div className="stat-label">Active Deals</div><div className="stat-value">{MOCK_DEALS.length}</div></div>
      <div className="stat-card"><div className="stat-label">Meetings</div><div className="stat-value">{MOCK_MEETINGS.length}</div></div>
      <div className="stat-card"><div className="stat-label">Team</div><div className="stat-value">{TEAM_MEMBERS.length}</div></div>
    </div>

    <div className="grid-2">
      <div className="card">
        <div className="card-header"><h3>Tasks Due Today</h3><span className="card-badge">{MOCK_TASKS_DUE.length}</span></div>
        {MOCK_TASKS_DUE.map(t => (
          <div key={t.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:"1px solid #334155"}}>
            <div><div style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{t.title}</div><div style={{fontSize:11,color:"#64748b"}}>{t.assignee}</div></div>
            <span className={"priority-tag priority-"+t.priority.toLowerCase()}>{t.priority}</span>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-header"><h3>Overdue Tasks</h3><span className="card-badge" style={{background:"#ef4444"}}>{MOCK_OVERDUE.length}</span></div>
        {MOCK_OVERDUE.map(t => (
          <div key={t.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:"1px solid #334155"}}>
            <div><div style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{t.title}</div><div style={{fontSize:11,color:"#64748b"}}>{t.assignee}</div></div>
            <span style={{fontSize:11,color:"#ef4444",fontWeight:600}}>{t.daysOverdue}d overdue</span>
          </div>
        ))}
      </div>
    </div>

    <div className="grid-2">
      <div className="card">
        <div className="card-header"><h3>Today's Meetings</h3></div>
        {MOCK_MEETINGS.map(m => (
          <div key={m.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:"1px solid #334155"}}>
            <div>
              <div style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{m.title}</div>
              <div style={{fontSize:11,color:"#64748b"}}>{m.time} - {m.attendees.join(", ")}</div>
            </div>
            <span className={"status-badge "+(m.type==="Client"?"status-active":"status-pending")}>{m.type}</span>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-header"><h3>Deals Pipeline</h3></div>
        {MOCK_DEALS.map(d => (
          <div key={d.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:"1px solid #334155"}}>
            <div>
              <div style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{d.name}</div>
              <div style={{fontSize:11,color:"#64748b"}}>{d.rep} - {d.stage}</div>
            </div>
            <div style={{textAlign:"right"}}>
              <div style={{fontSize:14,fontWeight:700,color:"#10b981"}}>{d.value}</div>
              <div style={{fontSize:11,color:"#64748b"}}>{d.probability}% likely</div>
            </div>
          </div>
        ))}
      </div>
    </div>

    <div className="card" style={{marginTop:16}}>
      <div className="card-header"><h3>Team Activity Feed</h3></div>
      <div className="activity-feed">
        {MOCK_ACTIVITY.map(a => (
          <div key={a.id} className="activity-item">
            <div className="activity-avatar">{a.user.split(" ").map(n=>n[0]).join("")}</div>
            <div className="activity-content">
              <div className="activity-text"><strong>{a.user}</strong> {a.action}</div>
              <div className="activity-time">{a.time}</div>
            </div>
          </div>
        ))}
      </div>
    </div>

    <div className="card" style={{marginTop:16}}>
      <div className="card-header"><h3>Team Status</h3></div>
      <div className="team-grid">
        {TEAM_MEMBERS.map(m => (
          <div key={m.name} style={{display:"flex",alignItems:"center",gap:12,padding:12,background:"#0f172a",borderRadius:8,border:"1px solid #334155"}}>
            <div className="user-avatar" style={{width:36,height:36,fontSize:12}}>{m.initials}</div>
            <div>
              <div style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{m.name}</div>
              <div style={{fontSize:11,color:"#10b981"}}>{m.role}</div>
            </div>
            <span className="status-badge status-active" style={{marginLeft:"auto",fontSize:10}}>Online</span>
          </div>
        ))}
      </div>
    </div>

    <div className="card" style={{marginTop:16}}>
      <div className="card-header"><h3>Weekly Performance Snapshot</h3></div>
      <div className="chart-bar-container">
        {TEAM_MEMBERS.map((m,i) => (
          <div key={m.name} className="chart-bar-row">
            <span className="chart-bar-label">{m.name.split(" ")[0]}</span>
            <div className="chart-bar-track">
              <div className="chart-bar-fill" style={{width:(70+Math.random()*30)+"%"}}>{Math.floor(5+Math.random()*12)} tasks</div>
            </div>
          </div>
        ))}
      </div>
    </div>

    <div className="grid-2" style={{marginTop:16}}>
      <div className="card">
        <div className="card-header"><h3>Department Breakdown</h3></div>
        {["Engineering","Sales","Finance","Operations","Mining","Commodities"].map(dept => (
          <div key={dept} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:"1px solid #334155"}}>
            <span style={{fontSize:13,color:"#e2e8f0"}}>{dept}</span>
            <div style={{display:"flex",gap:12}}>
              <span style={{fontSize:12,color:"#10b981"}}>{Math.floor(3+Math.random()*8)} tasks</span>
              <span style={{fontSize:12,color:"#64748b"}}>{Math.floor(1+Math.random()*3)} members</span>
            </div>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-header"><h3>Key Metrics This Week</h3></div>
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontSize:13,color:"#94a3b8"}}>Tasks Completed</span>
            <span style={{fontSize:16,fontWeight:700,color:"#10b981"}}>34</span>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontSize:13,color:"#94a3b8"}}>Tasks Created</span>
            <span style={{fontSize:16,fontWeight:700,color:"#3b82f6"}}>28</span>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontSize:13,color:"#94a3b8"}}>Deals Closed</span>
            <span style={{fontSize:16,fontWeight:700,color:"#10b981"}}>3</span>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontSize:13,color:"#94a3b8"}}>Calls Made</span>
            <span style={{fontSize:16,fontWeight:700,color:"#f1f5f9"}}>47</span>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontSize:13,color:"#94a3b8"}}>Site Visits</span>
            <span style={{fontSize:16,fontWeight:700,color:"#f1f5f9"}}>6</span>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontSize:13,color:"#94a3b8"}}>Revenue Closed</span>
            <span style={{fontSize:16,fontWeight:700,color:"#10b981"}}>75,000</span>
          </div>
        </div>
      </div>
    </div>
  </div>);
}